import { injectable } from "inversify";
import { IDownloadHandler } from "./DownloadHandler";
import "reflect-metadata";
import { IDownload, MimeTypes } from "../types";
import { DownloadError } from "@/core/errors/DownloadError";

@injectable()
export default class AbstractDownloadHandler implements IDownloadHandler {
  private nextHandler: IDownloadHandler | null = null;

  setNext(handler: IDownloadHandler): IDownloadHandler {
    this.nextHandler = handler;

    return this.nextHandler;
  }

  handle(mimeType: MimeTypes): IDownload | null {
    if (this.nextHandler) {
      return this.nextHandler.handle(mimeType);
    }

    throw new DownloadError({
      message: "Não foi possível baixar o arquivo",
      cause: new Error("Não foi possível encontrar o formato do arquivo")
    });
  }
}
